import styled from 'styled-components';
import { CompanyRanking } from 'Types/CompaniesTypes';
import {
  boxShadow, secondaryFont, wMedium, maxWidth, retina, maxTablet,
} from '../../../Utils/utilsStyle';

type Props = {
  colorText?: string,
  sizeText?: string,
  sizeTextSm?: string,
  rankItem: CompanyRanking
} & typeof defaultProps;

const defaultProps = {
  colorText: '',
  sizeText: '',
  sizeTextSm: '',
};

const Wrapper = styled.div< { colorText: string, sizeText: string, sizeTextSm: string, colorOne: string, colorTwo: string, } >`
  box-shadow: ${boxShadow};
  border-radius: 8px;
  text-align:center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  span {
    display:block;
  }
  .title {
    color: ${(props) => props.colorText};
    font-family: ${secondaryFont};
    font-weight: ${wMedium};
    font-size: ${(props) => props.sizeText};
    line-height: ${(props) => props.sizeText};;
    letter-spacing: -0.97;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: ${(props) => props.sizeTextSm};
      line-height:  ${(props) => props.sizeTextSm};
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 38px;
      line-height: 40px;
    }
  }
  .companyName{
    color: #67696A;
    font-family: ${secondaryFont};
    font-weight: ${wMedium};
    font-size: 20px !important;
    line-height: 1.211;
    letter-spacing: -0.49;
    margin-top: 25px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin-top: 15px;
      font-size: 16px !important;
    }
  }
  .topBanner{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .bottomBanner {
    background-color: ${(props) => props.colorOne};
    background: linear-gradient(90deg, ${(props) => props.colorOne} 0%, ${(props) => props.colorTwo} 100%);
    color: white;
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size:34px;
    width:100%;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

const Ranking = function Ranking(props: Props) {
  const {
    colorText, sizeText, sizeTextSm, rankItem,
  } = props;

  return (
    <Wrapper
      colorText={colorText}
      sizeText={sizeText}
      sizeTextSm={sizeTextSm}
      colorOne={rankItem.colors[0]}
      colorTwo={rankItem.colors[1]}
    >
      <div className="topBanner">
        <span className="companyName">Rank:</span>
        <span className="title">{rankItem.rank}</span>
      </div>

      <div className="bottomBanner">
        <img src={rankItem.image} alt="rank-img" className="img-ranking" />
      </div>
    </Wrapper>
  );
};

Ranking.defaultProps = defaultProps;

export default Ranking;
